import React from 'react';
import PillarMaterialsSection from '../portal/PillarMaterialsSection';

/**
 * CRM-managed sales materials on the portal Sales dashboard. Sections and
 * templates are edited from CRM → Templates → Sales Materials
 * (templatesStructures/sales + templatesCollections docs with pillar 'Sales').
 */
const SalesMaterialsSection = ({ standalone = false }) => (
  <PillarMaterialsSection
    standalone={standalone}
    pillar="Sales"
    structureId="sales"
    idPrefix="sales-material"
    emptyText="Sales materials are on the way — check back soon."
  />
);

export default SalesMaterialsSection;
